import React, { FC, useState } from 'react'
import ReactMarkdown from 'react-markdown'

import { FlexContainer, InfoTooltip } from '@avantstay/backoffice-core'
import { IconChevronDown, IconGlitter } from '@avantstay/backoffice-vectors'

import * as S from './AIElements.styles'

interface CollapsibleCardProps {
  title: string
  content: string
  titleTooltip?: string
}

export const CollapsibleCard: FC<CollapsibleCardProps> = ({ title, content, titleTooltip }) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  return (
    <S.CardBorder>
      <S.Card>
        <S.CardTitle onClick={() => setIsCollapsed(!isCollapsed)}>
          <FlexContainer justify="flex-start" gap={12} noWrap>
            <S.CardIcon>
              <IconGlitter width={24} height={24} />
            </S.CardIcon>
            <FlexContainer justify="flex-start" gap={4} noWrap>
              {title} {titleTooltip ? <InfoTooltip info={titleTooltip} placement="top" /> : null}
            </FlexContainer>
          </FlexContainer>

          <S.IconCollapsible scale={isCollapsed ? 1 : -1}>
            <IconChevronDown />
          </S.IconCollapsible>
        </S.CardTitle>

        {!isCollapsed ? (
          <S.ContentWrapper>
            <ReactMarkdown>{content}</ReactMarkdown>
          </S.ContentWrapper>
        ) : null}
      </S.Card>
    </S.CardBorder>
  )
}
